export default {
  reviewCompleteHeader: 'Completer et valider',
  participants: 'Participants',
  enterParticipantInfoText:
    'Veuillez completer les informations de tous les participants à l’expérience.',
  purchaser: 'Coordonnées de l’acheteur',
  firstName: 'Prénom',
  lastName: 'Nom',
  email: 'Email*:',
  optionalEmail: 'Email: (optionnel)',
  duplicatePurchaserText: 'Identique à l’acheteur',
  phone: 'Téléphone: (optionnel)',
  addParticipant: 'Ajouter {{tierLabel}}',
  participant: 'Participant',
  removeParticipant: 'Enlever Participant',
  experienceCheckoutCompleted: "Finalisation de l'expérience",
  experienceCartCheckout: "Panier d'expérience - Paiement",
  experienceLimitReached: 'Désolé cette expérience est complète',
  payment: 'Paiement',
  duration: 'Durée',
  discountCode: 'Code promotionnel',
  removeCode: 'Supprimer le code',
  invalidCodeValidation: 'Code invalide',
  networkErrorDiscountCode: 'Une erreur s’est produite',
  onlyOneCouponCodeAllowed: 'Un seul code promotionnel est autorisé',
  creditCodeHasAlreadyBeenApplied: 'Le code crédit a déjà été appliqué',
  discount: 'Réduction',
  promo: 'Promo',
  promoCode: 'Code promo',
  apply: 'Appliquer',
  total: 'Total',
  subTotal: 'Sous-total',
  includes: 'Inclus',
  and: 'et',
  addHostNotes: 'Ajouter des commentaires pour votre hôte',
  brandAggreementText: 'J’ai lu et j’accepte les conditions de',
  termsAggreementValidation: 'Veuillez accepter les termes',
  firstNameValidation: 'Prénom requis',
  lastNameValidation: 'Nom requis',
  emailValidation: {
    emailRequiredText: 'Email requis',
    'Invalid Email Address': 'Adresse email invalide',
    not_specified: 'Adresse électronique incorrecte',
  },
  phoneValidation: {
    'Invalid Phone Number': 'téléphone invalide',
    not_specified: 'invalide',
  },
  participantFirstNameValidation: 'Prénom du participant requis',
  participantLastNameValidation: 'Nom du participant requis',
  complete: 'Valider',
  '404Message': 'Non trouvé',
  waiting: 'reservation en cours...',
  complimentary: 'Gratuit',
  confirmationHeader: 'Vous avez réservé votre expérience',
  confirmationText:
    'Un email de confirmation va vous être envoyé avec les détails de la réservation',
  viewAll: 'Voir toutes les expériences',
  paymentMethod: 'Méthode de paiement',
  creditCard: 'Carte de crédit',
  roomCharge: 'Paiement par numéro de chambre',
  memberCharge: 'Paiement par numéro de membre',
  roomNumber: 'Numéro de chambre',
  memberNumber: 'Numéro de membre',
  chargeValidation: 'Le numéro de chambre et nom sont requis',
  memberNumberValidation: 'Le numéro de membre et nom sont requis',
  invalidRoomNumber: 'Numéro de chambre invalide',
  invalidMemberNumber: 'Numéro de membre invalide',
  cardNumberIncomplete: 'Numéro de carte incomplet',
  lastNameValidationError: 'Le nom de famille est obligatoire',
  isReqd: 'requis',
  // cart
  proceedToCheckout: 'Finaliser la commande',
  addToCart: 'Ajouter au panier',
  participantDetails: 'Liste des participants',
  editParticipantsDetails: 'Modifier les participants',
  fullName: 'Nom et prénom',
  checkout: 'Finaliser la commande',
  reservationSummary: 'Votre commande',
  editParticipants: 'Modifier',
  private: 'Privé',
  browseAllExperieces: 'Voir toutes les expériences',
  payWithCreditCard: 'Payer par carte de crédit',
  payWithRoomCharge: 'Payer par numéro de chambre',
  payWithMemberCharge: 'Payer par numéro de membre',
  payWith: 'Payer avec',
  bookBulkErrorByCard:
    "Un problème est survenu lors de la confirmation de votre réservation. Votre carte n'a pas été débitée.",
  bookBulkErrorByRoomCharge: 'Nom de famille et numéro de chambre non valides.',
  bookBulkErrorByMemberCharge:
    'Nom de famille et numéro de membre non valides.',
  reviewCancellation: 'Confirmation de l’annulation',
  selectAReservationToCancel: 'Sélectionnez une réservation à annuler',
  confirmCancellation: 'Confirmer l’annulation',
  cancellable: 'Annulable',
  cancelled: 'Annulé',
  deadlinePassed: 'Date limite dépassée',
  noCancellations: 'Non annulable',
  reviewReschedule: 'Votre réservation',
  selectAReservationToReschedule: 'Sélectionnez une réservation à reprogrammer',
  confirmReservation: 'Confirmer la réservation',
  confirm: 'Confirmer',
  selectADateAndTime: 'Sélectionnez une date et une heure',
  noOtherSessionsAvailableForThisExperience:
    'Aucune autre session n’est disponible pour cette expérience.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Cette réservation ne peut plus être reprogrammée. Veuillez envoyer un e-mail à {{brandEmail}}',
  thisReservationCannotBeRescheduled:
    'Cette réservation ne peut pas être reprogrammée',
  noTimesAvailable: 'Aucun horaire disponible',
  noBookingsAvailable: 'Aucune réservation disponible',
  youPaid: 'Vous avez payé',
  refund: 'Remboursement',
  yourRefund: 'Votre remboursement',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Votre remboursement sera traité sur le paiement original.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Cette réservation ne peut plus être annulée. Veuillez envoyer un email à {{brandEmail}}',
  reservationCancelled: 'Réservation annulée',
  thisReservationCannotBeCancelled:
    'Cette réservation ne peut pas être annulée',
  thisReservationHasAlreadyBeenCancelled:
    'Cette réservation a déjà été annulée',
  theHotel: 'l’Hôtel',
  cancelling: 'Annulation',
  somethingWentWrong: 'Une erreur est survenue',
  previouslyRefunded: 'Remboursé précédemment',
  remainingBalance: 'Solde restant',
  phoneNumber: 'Numéro de téléphone',
  requestToBookConfirmationText:
    'Un email de confirmation a été envoyé à {{email}}',
  reservationRescheduled: 'Réservation replanifiée',
  yourReservationWasRescheduledTo: 'Votre réservation a été replanifiée pour',
  viewExperiences: 'Voir les expériences',
  joinBook: 'Rejoindre et réserver',
  signInBook: 'Se connecter et réserver',
  signAndJoin: 'Se connecter ou rejoindre pour réserver',
  signAndJoinDescription:
    "Les expériences World of Hyatt sont exclusives aux membres World of Hyatt. Connectez-vous ou rejoignez-vous pour réserver et gagner des points. Préférez-vous ne pas rejoindre? Vous pouvez toujours réserver des expériences non exclusives en supprimant l'expérience World of Hyatt de votre panier.",
  promoOrFind: 'Code promotionnel ou code crédit FIND',
  hyattTermsAndConditions: 'Conditions générales',
  hyattTermsAndConditionsAgreement:
    'En confirmant cette réservation, j’accepte la politique d’annulation. J’ai également lu et pris connaissance de l’utilisation de mes données personnelles conformément aux',
  hyattTermsAndConditionsLink: 'Politiques de confidentialité de Hyatt',
  hyattWaiverText:
    'En achetant cette expérience, je consens, comprends et reconnais, tant en mon nom qu’au nom de toute personne participant à l’expérience achetée par moi (le cas échéant), ce qui suit',
  hyattWaiverLink: 'décharge générale',
  priceDisclaimer: 'Inclut les frais avant taxes',
  curatedRecommendations: 'Recommandations personnalisées',
  moreExperiencesYouMightLike: 'Autres expériences que vous pourriez aimer',
  similarExperiencesAvailableToBookDirectly:
    'Expériences similaires disponibles à la réservation directe',
  experiencesAvailableAroundYourBookingDate:
    'Expériences disponibles autour de votre date de réservation',
  confirmationEmailSent:
    'Nous avons envoyé votre confirmation à {{email}} avec plus de détails.',
  youreBooked: 'Vous avez réservé',
  purchaserInformation: "Informations de l'acheteur",
  requiredFieldIndicator: '* indique un champ obligatoire',
  resourceSelectionTitle: 'Choisissez vos options',
  resourceSelectionDescription:
    'Choisissez une option pour chaque élément de votre réservation.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Sélectionnez {{attributeName}}',
  resourceValueSoldOut: '{{label}} (épuisé)',
  resourceValueUnavailableWith: '{{label}} (non disponible avec {{picks}})',
  resourceOptionsUnavailable:
    "Nous n'avons pas pu charger les options pour cet horaire. Veuillez réessayer.",
  resourceOptionsRetry: 'Réessayer',
  changeResourceSelections: 'Modifier vos choix',
};
